import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash, faEye } from '@fortawesome/free-regular-svg-icons'
import { getMarginTotal } from 'Utils/functions'

/**
 * Generates the configuration for the "Margen" column used in a table.
 * This column displays the margin percentage for each row and allows
 * toggling visibility globally or per row.
 *
 * @param {Object} params - Configuration parameters.
 * @param {boolean} params.showAll - Indicates whether all rows are currently visible.
 * @param {Function} params.toggleAll - Toggles visibility for all rows.
 * @param {Function} params.toggleRow - Toggles visibility for a specific row.
 * @param {Function} params.isRowVisible - Determines if a specific row is visible.
 * @param {React.ReactNode} [params.footer] - Optional footer component for the column.
 *
 * @returns {Object} Column definition object compatible with react-table.
 */
export const getMarginColumn = ({
  showAll,
  toggleAll,
  toggleRow,
  isRowVisible,
  footer,
}) => ({
  id: 'Margen',
  Header: () => (
    <div className="d-flex align-items-center gap-2">
      <span className="d-inline-flex align-items-center">Margen</span>

      <span
        className="d-inline-flex align-items-center"
        style={{ cursor: 'pointer' }}
        onClick={toggleAll}>
        {showAll ? (
          <FontAwesomeIcon icon={faEye} />
        ) : (
          <FontAwesomeIcon icon={faEyeSlash} />
        )}
      </span>
    </div>
  ),
  accessor: 'Margen',
  Cell: ({ row }) => {
    const visible = isRowVisible(row.id)

    const { Price, Cost, AvgCost, Quantity } = row.original

    const margin = getMarginTotal(Price, Cost || AvgCost, Quantity).toFixed(2)

    return (
      <div className="d-flex align-items-center gap-2">
        <span style={{ lineHeight: 1 }}>{visible ? `${margin}%` : '****'}</span>

        <span
          style={{ cursor: 'pointer', lineHeight: 1 }}
          onClick={() => toggleRow(row.id)}>
          {visible ? (
            <FontAwesomeIcon icon={faEye} />
          ) : (
            <FontAwesomeIcon icon={faEyeSlash} />
          )}
        </span>
      </div>
    )
  },
  ...(footer && { Footer: footer }),
})
